import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "@/model/utils";

import { HighlightText } from "@/shared/lib/high-light-text";

import {
  TEXT_SIZES,
  TEXT_SIZES_VARIABLES,
  TEXT_VARIANTS,
  TEXT_VARIANTS_VARIABLES,
} from "./constants";
import { TAG } from "./model";

const textVariant = cva("", {
  variants: {
    variant: {
      default: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.default],
      error: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.error],
      link: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.link],
      primary: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.primary],
      secondary: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.secondary],
      tertiary: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.tertiary],
      fourth: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.fourth],
      title: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.title],

      // subTitle: TEXT_VARIANTS[TEXT_VARIANTS_VARIABLES.subTitle],
    },
    size: {
      xs: TEXT_SIZES[TEXT_SIZES_VARIABLES.xs],
      default: TEXT_SIZES[TEXT_SIZES_VARIABLES.default],

      medium: TEXT_SIZES[TEXT_SIZES_VARIABLES.medium],
      large: TEXT_SIZES[TEXT_SIZES_VARIABLES.large],
      xl: TEXT_SIZES[TEXT_SIZES_VARIABLES.xl],
      // xxl: TEXT_SIZES[TEXT_SIZES_VARIABLES.xxl],
      xxxl: TEXT_SIZES[TEXT_SIZES_VARIABLES.xxxl],
      // xxxxl: TEXT_SIZES[TEXT_SIZES_VARIABLES.xxxxl],
    },
  },
  defaultVariants: {
    variant: TEXT_VARIANTS_VARIABLES.default,
    size: TEXT_SIZES_VARIABLES.default,
  },
});

type AppTextProps = HTMLAttributes<HTMLDivElement> & {
  highlight?: string | string[];
  classNameHighLight?: string;
  variant?: keyof typeof TEXT_VARIANTS_VARIABLES;
  size?: keyof typeof TEXT_SIZES_VARIABLES;
  tag?: TAG;
} & VariantProps<typeof textVariant> & {
    asChild?: boolean;
  };

export const AppText = ({
  children,
  className,
  classNameHighLight,
  highlight,
  variant,
  size,
  tag,
}: AppTextProps) => {
  return (
    <TextWrapper variant={variant} size={size} tag={tag} className={className}>
      <HighlightText highlight={highlight} className={classNameHighLight}>
        {children}
      </HighlightText>
    </TextWrapper>
  );
};

function TextWrapper({
  children,
  variant,
  size,
  className,
  tag = TAG.span,
}: AppTextProps) {
  const Tag = tag;

  return (
    <Tag className={cn(textVariant({ variant, size, className }))}>
      {children}
    </Tag>
  );
}
